
import React from 'react';
import SignUpButton from '@/components/auth/SignUpButton';
import { Zap } from 'lucide-react';

const FinalCTASection = () => {
  return (
    <section className="py-12 sm:py-16 px-4 sm:px-6 bg-[#FAF9F6]">
      <div className="max-w-2xl mx-auto text-center">
        <div className="space-y-6">
          <SignUpButton 
            text="Crear Cuenta Gratis"
            className="w-full sm:w-auto px-8 py-4 text-lg font-semibold min-h-[50px] bg-[#2563EB] hover:bg-blue-700 shadow-lg hover:shadow-xl transition-all duration-300"
          />
          
          <div className="flex items-center justify-center gap-2">
            <Zap className="h-4 w-4 text-green-500" />
            <p 
              className="text-base sm:text-lg text-gray-600 leading-relaxed"
              style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
            >
              Completamente gratis después de registrarte. Sin tarjeta de crédito requerida.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
